import { Injectable, SecurityContext } from '@angular/core';
import { GiftCardDetails, GiftCardPreview } from '~models/shop-gift-card.model';
import { Denomination, ETagProduct, ETagType, GiftCardV2, Vendor } from '~models';

@Injectable()
export class ShopCentralService {
  constructor() {}

  convertGiftCardDetailsToGiftCardV2(card: GiftCardDetails): GiftCardV2 {
    const terms = card.terms
      ? `${card.terms}\n\n${card?.cashbackSummary?.cashbackTerms}`
      : card?.cashbackSummary?.cashbackTerms;

    return {
      customDenominations:
        card.denominations.custom != null
          ? [
              {
                minPrice: card.denominations.custom.minPrice,
                maxPrice: card.denominations.custom.maxPrice,
              },
            ]
          : [],
      importantContent: card.description,
      isFixedValue: card.denominations.isFixedValue === true,
      merchantId: card.merchantId.toString(),
      terms,
      termsLink: card.termsLink,
      vendor: Vendor[card.vendor],
      id: card.id,
      image: card.imageUrl,
      brand: card.brand,
      cardTypeStatus: 'AVAILABLE',
      deliveryInstructions: card.deliveryInstruction,
      tags: [
        {
          type: card.cashbackSummary != null ? ETagType.CASHBACK : ETagType.PLAIN,
          text: card?.cashbackSummary?.cashbackOffer || card.promotionalOffer || '',
          products: [],
        },
      ],
      denominations: card.denominations.fixed.map(
        (d) => new Denomination(d.price, d.currency, d.stock),
      ),
    };
  }

  convertGiftCardPreviewToGiftCardV2(card: GiftCardPreview): GiftCardV2 {
    return {
      customDenominations: [],
      featured: false,
      isFixedValue: false,
      id: card.entryId,
      image: card.imageUrl,
      brand: card.brand,
      vendor: Vendor[card.vendor],
      cardTypeStatus: 'AVAILABLE',
      tags: [
        {
          type: card.cashbackSummary != null ? ETagType.CASHBACK : ETagType.PLAIN,
          text: card?.cashbackSummary?.cashbackOffer || card.promotionalOffer || '',
          products: [],
        },
      ],
      denominations: [],
    };
  }
}
